import React, { useState, useEffect, useRef } from 'react';

// SVG Icon Components
const RobotIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <rect x="14" y="18" width="20" height="18" rx="3" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <rect x="19" y="8" width="10" height="10" rx="2" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <line x1="24" y1="18" x2="24" y2="8" stroke="#ff4444" strokeWidth="2"/>
    <circle cx="20" cy="24" r="2.5" fill="#ff4444"/>
    <circle cx="28" cy="24" r="2.5" fill="#ff4444"/>
    <rect x="18" y="30" width="12" height="3" rx="1.5" fill="#ff4444" opacity="0.6"/>
    <line x1="14" y1="22" x2="8" y2="26" stroke="#ff4444" strokeWidth="2"/>
    <line x1="34" y1="22" x2="40" y2="26" stroke="#ff4444" strokeWidth="2"/>
    <line x1="19" y1="36" x2="17" y2="44" stroke="#ff4444" strokeWidth="2"/>
    <line x1="29" y1="36" x2="31" y2="44" stroke="#ff4444" strokeWidth="2"/>
    <circle cx="10" cy="4" r="1.5" fill="#ff4444" opacity="0.5"/>
    <circle cx="38" cy="4" r="1.5" fill="#ff4444" opacity="0.5"/>
  </svg>
);

const TrophyIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path d="M14 6h20v18a10 10 0 01-20 0V6z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M6 8h8v8a4 4 0 01-8 0V8z" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <path d="M34 8h8v8a4 4 0 01-8 0V8z" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <line x1="24" y1="34" x2="24" y2="40" stroke="#ff4444" strokeWidth="2"/>
    <rect x="16" y="40" width="16" height="3" rx="1.5" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M19 18 l5 4 l5-8" stroke="#ff0044" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const RocketIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path d="M24 4 C24 4 34 12 34 26 L24 36 L14 26 C14 12 24 4 24 4z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <circle cx="24" cy="20" r="4" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.2)"/>
    <path d="M14 26 L8 38 L18 34" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <path d="M34 26 L40 38 L30 34" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <path d="M20 36 L18 44 L24 40 L30 44 L28 36" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
  </svg>
);

const ChipIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <rect x="14" y="14" width="20" height="20" rx="3" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <rect x="18" y="18" width="12" height="12" rx="2" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <line x1="18" y1="8" x2="18" y2="14" stroke="#ff4444" strokeWidth="2"/>
    <line x1="24" y1="8" x2="24" y2="14" stroke="#ff4444" strokeWidth="2"/>
    <line x1="30" y1="8" x2="30" y2="14" stroke="#ff4444" strokeWidth="2"/>
    <line x1="18" y1="34" x2="18" y2="40" stroke="#ff4444" strokeWidth="2"/>
    <line x1="24" y1="34" x2="24" y2="40" stroke="#ff4444" strokeWidth="2"/>
    <line x1="30" y1="34" x2="30" y2="40" stroke="#ff4444" strokeWidth="2"/>
    <line x1="8" y1="18" x2="14" y2="18" stroke="#ff4444" strokeWidth="2"/>
    <line x1="8" y1="24" x2="14" y2="24" stroke="#ff4444" strokeWidth="2"/>
    <line x1="8" y1="30" x2="14" y2="30" stroke="#ff4444" strokeWidth="2"/>
    <line x1="34" y1="18" x2="40" y2="18" stroke="#ff4444" strokeWidth="2"/>
    <line x1="34" y1="24" x2="40" y2="24" stroke="#ff4444" strokeWidth="2"/>
    <line x1="34" y1="30" x2="40" y2="30" stroke="#ff4444" strokeWidth="2"/>
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path d="M24 4 L28 17 L42 17 L31 25 L35 38 L24 30 L13 38 L17 25 L6 17 L20 17 Z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.15)" strokeLinejoin="round"/>
    <circle cx="24" cy="20" r="3" fill="#ff4444" opacity="0.6"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="18" stroke="#ff4444" strokeWidth="2"/>
    <circle cx="24" cy="24" r="12" stroke="#ff4444" strokeWidth="2" opacity="0.7"/>
    <circle cx="24" cy="24" r="6" stroke="#ff4444" strokeWidth="2" opacity="0.5"/>
    <circle cx="24" cy="24" r="2" fill="#ff4444"/>
    <line x1="24" y1="6" x2="24" y2="2" stroke="#ff4444" strokeWidth="2"/>
    <line x1="24" y1="42" x2="24" y2="46" stroke="#ff4444" strokeWidth="2"/>
    <line x1="6" y1="24" x2="2" y2="24" stroke="#ff4444" strokeWidth="2"/>
    <line x1="42" y1="24" x2="46" y2="24" stroke="#ff4444" strokeWidth="2"/>
  </svg>
);

const GearIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="8" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M24 4 L26 10 L22 10 Z" fill="#ff4444"/>
    <path d="M24 44 L26 38 L22 38 Z" fill="#ff4444"/>
    <path d="M4 24 L10 22 L10 26 Z" fill="#ff4444"/>
    <path d="M44 24 L38 22 L38 26 Z" fill="#ff4444"/>
    <path d="M8.7 8.7 L13.5 13.1 L10.7 15.9 Z" fill="#ff4444"/>
    <path d="M39.3 39.3 L34.5 34.9 L37.3 32.1 Z" fill="#ff4444"/>
    <path d="M8.7 39.3 L13.1 34.5 L15.9 37.3 Z" fill="#ff4444"/>
    <path d="M39.3 8.7 L34.9 13.5 L32.1 10.7 Z" fill="#ff4444"/>
    <circle cx="24" cy="24" r="4" fill="#ff4444" opacity="0.3"/>
  </svg>
);

const DroneIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <rect x="20" y="20" width="8" height="8" rx="2" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.2)"/>
    <line x1="20" y1="20" x2="12" y2="12" stroke="#ff4444" strokeWidth="1.5"/>
    <line x1="28" y1="20" x2="36" y2="12" stroke="#ff4444" strokeWidth="1.5"/>
    <line x1="20" y1="28" x2="12" y2="36" stroke="#ff4444" strokeWidth="1.5"/>
    <line x1="28" y1="28" x2="36" y2="36" stroke="#ff4444" strokeWidth="1.5"/>
    <ellipse cx="12" cy="12" rx="5" ry="3" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <ellipse cx="36" cy="12" rx="5" ry="3" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <ellipse cx="12" cy="36" rx="5" ry="3" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <ellipse cx="36" cy="36" rx="5" ry="3" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <circle cx="24" cy="24" r="2" fill="#ff4444"/>
  </svg>
);

const GraphIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <polyline points="6,38 14,26 22,30 30,16 38,10" stroke="#ff4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <circle cx="6" cy="38" r="2.5" fill="#ff4444"/>
    <circle cx="14" cy="26" r="2.5" fill="#ff4444"/>
    <circle cx="22" cy="30" r="2.5" fill="#ff4444"/>
    <circle cx="30" cy="16" r="2.5" fill="#ff4444"/>
    <circle cx="38" cy="10" r="2.5" fill="#ff4444"/>
    <line x1="6" y1="42" x2="42" y2="42" stroke="#ff4444" strokeWidth="1.5" opacity="0.5"/>
    <line x1="6" y1="6" x2="6" y2="42" stroke="#ff4444" strokeWidth="1.5" opacity="0.5"/>
  </svg>
);

// Animated Circuit Background
const CircuitBackground = () => (
  <svg className="circuit-bg" viewBox="0 0 1400 900" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
    {/* Horizontal lines */}
    <line x1="0" y1="150" x2="300" y2="150" stroke="#ff4444" strokeWidth="0.5" opacity="0.15"/>
    <line x1="300" y1="150" x2="300" y2="250" stroke="#ff4444" strokeWidth="0.5" opacity="0.15"/>
    <line x1="300" y1="250" x2="600" y2="250" stroke="#ff4444" strokeWidth="0.5" opacity="0.15"/>
    <line x1="1100" y1="100" x2="1400" y2="100" stroke="#ff4444" strokeWidth="0.5" opacity="0.12"/>
    <line x1="1100" y1="100" x2="1100" y2="300" stroke="#ff4444" strokeWidth="0.5" opacity="0.12"/>
    <line x1="900" y1="300" x2="1100" y2="300" stroke="#ff4444" strokeWidth="0.5" opacity="0.12"/>
    <line x1="0" y1="600" x2="200" y2="600" stroke="#ff4444" strokeWidth="0.5" opacity="0.1"/>
    <line x1="200" y1="600" x2="200" y2="750" stroke="#ff4444" strokeWidth="0.5" opacity="0.1"/>
    <line x1="200" y1="750" x2="500" y2="750" stroke="#ff4444" strokeWidth="0.5" opacity="0.1"/>
    <line x1="900" y1="700" x2="1400" y2="700" stroke="#ff4444" strokeWidth="0.5" opacity="0.12"/>
    <line x1="900" y1="600" x2="900" y2="700" stroke="#ff4444" strokeWidth="0.5" opacity="0.12"/>
    {/* Nodes */}
    <circle cx="300" cy="150" r="3" fill="#ff4444" opacity="0.3"/>
    <circle cx="300" cy="250" r="3" fill="#ff4444" opacity="0.3"/>
    <circle cx="600" cy="250" r="5" fill="none" stroke="#ff4444" strokeWidth="1" opacity="0.3"/>
    <circle cx="1100" cy="100" r="3" fill="#ff4444" opacity="0.25"/>
    <circle cx="1100" cy="300" r="3" fill="#ff4444" opacity="0.25"/>
    <circle cx="900" cy="300" r="5" fill="none" stroke="#ff4444" strokeWidth="1" opacity="0.25"/>
    <circle cx="200" cy="600" r="3" fill="#ff4444" opacity="0.2"/>
    <circle cx="200" cy="750" r="3" fill="#ff4444" opacity="0.2"/>
    <circle cx="900" cy="700" r="3" fill="#ff4444" opacity="0.22"/>
    {/* Grid dots */}
    {[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300].map(x =>
      [150, 300, 450, 600, 750].map(y => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="1" fill="#ff4444" opacity="0.07"/>
      ))
    )}
    {/* Diagonal accents */}
    <line x1="650" y1="0" x2="750" y2="100" stroke="#ff4444" strokeWidth="0.5" opacity="0.1"/>
    <line x1="1200" y1="500" x2="1400" y2="700" stroke="#ff4444" strokeWidth="0.5" opacity="0.08"/>
  </svg>
);

// Scanline overlay
const ScanlineOverlay = () => (
  <div className="scanlines" aria-hidden="true"/>
);

const Welcome = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('join');
  const [glitch, setGlitch] = useState(false);
  const heroRef = useRef(null);
  const ctaLinks = {
    registrationForm: 'https://forms.gle/your-registration-form-link',
    hrEmail: 'mailto:utmrbchr@gmail.com',
    partnershipEmail: 'mailto:utmroboconsecretary@gmail.com',
    proposalLink: 'https://drive.google.com/file/d/your-proposal-link/view'
  };

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
    // Occasional glitch effect on title
    const glitchInterval = setInterval(() => {
      setGlitch(true);
      setTimeout(() => setGlitch(false), 200);
    }, 5000);
    return () => clearInterval(glitchInterval);
  }, []);

  const achievements = [
    { number: "15+", label: "Int'l Competitions" },
    { number: "20+", label: "Team Members" },
    { number: "1ST", label: "ABU Robocon 2017" },
    { number: "5+", label: "Industry Partners" }
  ];

  const joinFeatures = [
    { icon: <TrophyIcon/>, title: 'Championship Glory', description: 'Represent Malaysia in ABU Robocon and compete against top universities across Asia-Pacific', highlight: 'International Recognition' },
    { icon: <RocketIcon/>, title: 'Career Acceleration', description: 'Build your portfolio with real projects. Our alumni work at MNC and local tech companies', highlight: '90% Job Placement' },
    { icon: <ChipIcon/>, title: 'Cutting-Edge Skills', description: 'Master AI, robotics, programming, and engineering design through hands-on challenges', highlight: 'Industry Training' }
  ];

  const sponsorBenefits = [
    { icon: <TargetIcon/>, title: 'Brand Visibility', description: 'Logo placement on robots, team uniforms, and international broadcast coverage reaching 1M+ viewers', highlight: 'Global Exposure' },
    { icon: <RobotIcon/>, title: 'Talent Pipeline', description: 'Direct access to top engineering students for internships and graduate recruitment', highlight: 'Early Talent Access' },
    { icon: <GearIcon/>, title: 'Innovation Partners', description: 'Collaborate on R&D projects and proof-of-concepts with our award-winning team', highlight: 'Tech Innovation' }
  ];

  const sponsorTiers = [
    { name: "PLATINUM", amount: "RM 50,000+", benefits: ["Prime logo placement", "Exclusive naming rights", "VIP event access", "Dedicated social media"], color: "#e5c76b", glow: "rgba(229,199,107,0.4)" },
    { name: "GOLD", amount: "RM 25,000+", benefits: ["Prominent logo display", "Competition event access", "Regular progress updates", "Social media mentions"], color: "#ff9944", glow: "rgba(255,153,68,0.35)" },
    { name: "SILVER", amount: "RM 10,000+", benefits: ["Logo on team materials", "Competition invitations", "Achievement reports", "Website listing"], color: "#aab4be", glow: "rgba(170,180,190,0.3)" }
  ];

  return (
    <div className="wc ext-page">
      <CircuitBackground/>
      <ScanlineOverlay/>
      <div className="noise-overlay"/>

      {/* HERO */}
      <section className={`hero ${isVisible ? 'visible' : ''}`} ref={heroRef}>
        <div className="hero-inner">
          <div className="hero-left">
            <div className="system-badge">
              <span className="sys-dot"/>
              <span className="sys-text">SYS_ACTIVE &nbsp;// UTM_ROBOCON_v2025</span>
            </div>
            <h1 className={`title ${glitch ? 'glitch' : ''}`} data-text="UTM ROBOCON">
              UTM<br/>
              <span className="title-accent">ROBO<span className="title-con">CON</span></span>
            </h1>
            <div className="title-bar">
              <div className="title-bar-line"/>
              <span className="title-bar-text">MALAYSIA'S PREMIER ROBOTICS TEAM</span>
              <div className="title-bar-line"/>
            </div>
            <p className="hero-desc">
              Engineering the future through competition, innovation, and relentless pursuit of <em>championship excellence</em>.
            </p>

            {/* LED Stats */}
            <div className="stats-row">
              {achievements.map((s, i) => (
                <div className="stat" key={i} style={{animationDelay: `${i * 0.15}s`}}>
                  <div className="stat-inner">
                    <div className="stat-num">{s.number}</div>
                    <div className="stat-lbl">{s.label}</div>
                    <div className="stat-line"/>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-right">
            <div className="selector-panel">
              <div className="panel-header">
                <span className="panel-tag">// INITIALIZE</span>
                <span className="panel-title">SELECT MODULE</span>
              </div>
              <div className="sel-btns">
                <button
                  className={`sel-btn ${activeSection === 'join' ? 'active' : ''}`}
                  onClick={() => setActiveSection('join')}
                >
                  <div className="sel-icon"><RobotIcon/></div>
                  <div className="sel-info">
                    <span className="sel-code">MOD_01</span>
                    <span className="sel-title">I'm a Student</span>
                    <span className="sel-sub">Join our championship team</span>
                  </div>
                  <svg className="sel-arrow" viewBox="0 0 24 24" width="20" height="20">
                    <polyline points="9,5 16,12 9,19" stroke="#ff4444" strokeWidth="2.5" fill="none"/>
                  </svg>
                </button>
                <button
                  className={`sel-btn ${activeSection === 'sponsor' ? 'active' : ''}`}
                  onClick={() => setActiveSection('sponsor')}
                >
                  <div className="sel-icon"><DroneIcon/></div>
                  <div className="sel-info">
                    <span className="sel-code">MOD_02</span>
                    <span className="sel-title">I'm a Company</span>
                    <span className="sel-sub">Partner with champions</span>
                  </div>
                  <svg className="sel-arrow" viewBox="0 0 24 24" width="20" height="20">
                    <polyline points="9,5 16,12 9,19" stroke="#ff4444" strokeWidth="2.5" fill="none"/>
                  </svg>
                </button>
              </div>
              <div className="panel-footer">
                <div className="pf-dot active"/>
                <div className="pf-dot"/>
                <div className="pf-dot"/>
                <span className="pf-text">READY</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTENT */}
      <section className="content-sec">
        <div className="sec-shell">
          <div className="content-wrap">
          <div className="content-head">
            <div className="ch-breadcrumb">
              <span className="ch-home">UTM_ROBOCON</span>
              <span className="ch-sep">/</span>
              <span className="ch-cur">{activeSection === 'join' ? 'STUDENT_MODULE' : 'SPONSOR_MODULE'}</span>
            </div>
            <h2 className="ch-title">
              {activeSection === 'join' ? 'WHY JOIN US?' : 'WHY SPONSOR US?'}
            </h2>
            <p className="ch-sub">
              {activeSection === 'join'
                ? 'Transform your engineering trajectory with world-class robotics experience'
                : 'Align your brand with champions — accelerate innovation together'}
            </p>
          </div>

          <div className="feat-grid" key={activeSection}>
            {(activeSection === 'join' ? joinFeatures : sponsorBenefits).map((f, i) => (
              <div className="feat-card" key={i} style={{animationDelay: `${i * 0.1}s`}}>
                <div className="fc-top">
                  <div className="fc-icon">{f.icon}</div>
                  <span className="fc-badge">{f.highlight}</span>
                </div>
                <h3 className="fc-title">{f.title}</h3>
                <p className="fc-desc">{f.description}</p>
                <div className="fc-glow-line"/>
              </div>
            ))}
          </div>

          {activeSection === 'sponsor' && (
            <div className="tiers-sec">
              <div className="tiers-header">
                <span className="tiers-tag">// PARTNERSHIP_TIERS</span>
                <h3 className="tiers-title">SPONSORSHIP MATRIX</h3>
              </div>
              <div className="tiers-grid">
                {sponsorTiers.map((t, i) => (
                  <div className="tier-card" key={i} style={{'--tier-color': t.color, '--tier-glow': t.glow}}>
                    <div className="tc-header">
                      <div className="tc-label">{t.name}</div>
                      <div className="tc-amount">{t.amount}</div>
                    </div>
                    <div className="tc-body">
                      {t.benefits.map((b, j) => (
                        <div className="tc-benefit" key={j}>
                          <svg width="14" height="14" viewBox="0 0 14 14">
                            <polyline points="2,7 5.5,10.5 12,3" stroke="var(--tier-color)" strokeWidth="2" fill="none" strokeLinecap="round"/>
                          </svg>
                          <span>{b}</span>
                        </div>
                      ))}
                    </div>
                    <div className="tc-glow"/>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* CTA */}
          <div className="cta-block">
            <div className="cta-inner">
              <div className="cta-left">
                <div className="cta-alert">
                  <div className="cta-pulse"/>
                  <span>{activeSection === 'join' ? '⚠ APPLICATIONS CLOSING SOON' : '⚡ SEASON STARTING NOW'}</span>
                </div>
                <h3 className="cta-h">
                  {activeSection === 'join' ? 'Ready to Build the Future?' : 'Ready to Power Champions?'}
                </h3>
                <p className="cta-p">
                  {activeSection === 'join'
                    ? "Secure your position in Malaysia's top robotics team. Applications are competitive — act now."
                    : 'Partner with us before the championship begins and maximize your brand exposure across Asia-Pacific.'}
                </p>
              </div>
              <div className="cta-right">
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => window.open(activeSection === 'join' ? ctaLinks.registrationForm : ctaLinks.partnershipEmail, '_blank')}
                >
                  <span className="btn-bg"/>
                  <span className="btn-text">
                    {activeSection === 'join' ? 'APPLY NOW' : 'BECOME SPONSOR'}
                  </span>
                </button>
                <button
                  className="btn-secondary"
                  type="button"
                  onClick={() => window.open(activeSection === 'join' ? ctaLinks.hrEmail : ctaLinks.proposalLink, '_blank')}
                >
                  <span>{activeSection === 'join' ? 'CONTACT TEAM' : 'GET PROPOSAL'}</span>
                </button>
              </div>
            </div>
          </div>

          <div className="switch-row">
            <span className="switch-label">Looking for something else?</span>
            <button className="switch-btn" onClick={() => setActiveSection(activeSection === 'join' ? 'sponsor' : 'join')}>
              {activeSection === 'join' ? '[MOD_02] Switch to Sponsor Info →' : '[MOD_01] Switch to Student Info →'}
            </button>
          </div>
          </div>
        </div>
      </section>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&family=Rajdhani:wght@300;400;500;600;700&family=Share+Tech+Mono&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .wc {
          position: relative;
          min-height: 100vh;
          background: #060608;
          overflow-x: hidden;
          font-family: 'Rajdhani', sans-serif;
          color: #e0e0e0;
        }

        /* Circuit BG */
        .circuit-bg {
          position: fixed;
          inset: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
        }

        /* Scanlines */
        .scanlines {
          position: fixed;
          inset: 0;
          z-index: 1;
          pointer-events: none;
          background: repeating-linear-gradient(
            0deg,
            transparent,
            transparent 2px,
            rgba(0,0,0,0.07) 2px,
            rgba(0,0,0,0.07) 4px
          );
        }

        /* Noise */
        .noise-overlay {
          position: fixed;
          inset: 0;
          z-index: 1;
          pointer-events: none;
          opacity: 0.03;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
          background-size: 200px 200px;
        }

        /* HERO */
        .hero {
          position: relative;
          z-index: 2;
          padding: 7rem var(--external-content-x) 4rem;
          max-width: var(--external-content-max-width);
          margin: 0 auto;
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.9s ease, transform 0.9s ease;
        }
        .hero.visible { opacity: 1; transform: none; }

        .hero-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 5rem;
          align-items: center;
        }

        /* System badge */
        .system-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,68,68,0.08);
          border: 1px solid rgba(255,68,68,0.25);
          border-radius: 2px;
          padding: 6px 14px;
          margin-bottom: 2rem;
        }
        .sys-dot {
          width: 8px; height: 8px; border-radius: 50%;
          background: #ff4444;
          box-shadow: 0 0 8px #ff4444;
          animation: pulse-dot 1.5s ease-in-out infinite;
        }
        @keyframes pulse-dot {
          0%,100%{opacity:1;box-shadow:0 0 8px #ff4444}
          50%{opacity:0.5;box-shadow:0 0 3px #ff4444}
        }
        .sys-text {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.72rem;
          color: #ff6666;
          letter-spacing: 1px;
        }

        /* Title */
        .title {
          font-family: 'Orbitron', sans-serif;
          font-size: clamp(3.2rem, 7vw, 6.5rem);
          font-weight: 900;
          color: #fff;
          line-height: 0.88;
          margin-bottom: 1.5rem;
          position: relative;
        }
        .title-accent {
          color: #fff;
          position: relative;
        }
        .title-con {
          color: #ff2222;
          text-shadow: 0 0 20px rgba(255,34,34,0.8), 0 0 40px rgba(255,34,34,0.4);
        }
        .title.glitch { animation: glitch 0.2s steps(2) forwards; }
        @keyframes glitch {
          0%{clip-path:inset(0 0 90% 0);transform:translateX(-4px)}
          25%{clip-path:inset(40% 0 40% 0);transform:translateX(4px)}
          50%{clip-path:inset(80% 0 0 0);transform:translateX(-2px)}
          75%{clip-path:inset(20% 0 60% 0);transform:translateX(0)}
          100%{clip-path:none;transform:none}
        }

        .title-bar {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.8rem;
        }
        .title-bar-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, #ff4444, transparent);
        }
        .title-bar-line:last-child { background: linear-gradient(90deg, transparent, #ff4444); }
        .title-bar-text {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.65rem;
          color: #ff6666;
          letter-spacing: 2.5px;
          white-space: nowrap;
        }

        .hero-desc {
          font-size: 1.15rem;
          color: #9da8b5;
          line-height: 1.7;
          margin-bottom: 2.5rem;
          font-weight: 400;
          max-width: 460px;
        }
        .hero-desc em { color: #ff8888; font-style: normal; font-weight: 600; }

        /* Stats */
        .stats-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1rem;
        }
        .stat {
          opacity: 0;
          animation: fadeup 0.5s ease forwards;
          animation-delay: var(--delay, 0s);
        }
        .hero.visible .stat { opacity: 0; } /* re-trigger on load */
        @keyframes fadeup { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:none} }
        .hero.visible .stat { animation: fadeup 0.5s ease forwards; }

        .stat-inner {
          background: rgba(255,68,68,0.06);
          border: 1px solid rgba(255,68,68,0.18);
          border-radius: 4px;
          padding: 1.2rem 0.8rem;
          min-height: 98px;
          text-align: center;
          position: relative;
          overflow: hidden;
          transition: border-color 0.3s, background 0.3s;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .stat-inner:hover {
          background: rgba(255,68,68,0.12);
          border-color: rgba(255,68,68,0.5);
        }
        .stat-num {
          font-family: 'Orbitron', sans-serif;
          font-size: 1.8rem;
          font-weight: 900;
          color: #ff3333;
          text-shadow: 0 0 12px rgba(255,51,51,0.6);
          margin-bottom: 0.3rem;
          letter-spacing: 1px;
        }
        .stat-lbl {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.58rem;
          color: #7a8a9a;
          letter-spacing: 1px;
          text-transform: uppercase;
          line-height: 1.3;
        }
        .stat-line {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent, #ff4444, transparent);
          animation: slide-line 3s ease-in-out infinite;
        }
        @keyframes slide-line {
          0%{opacity:0;transform:scaleX(0)}
          50%{opacity:1;transform:scaleX(1)}
          100%{opacity:0;transform:scaleX(0)}
        }

        /* Selector Panel */
        .selector-panel {
          background: rgba(10,10,14,0.9);
          border: 1px solid rgba(255,68,68,0.25);
          border-radius: 6px;
          padding: 2.5rem;
          position: relative;
          overflow: hidden;
        }
        .selector-panel::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #ff4444, transparent);
        }
        .panel-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }
        .panel-tag {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.68rem;
          color: #555;
          letter-spacing: 1px;
        }
        .panel-title {
          font-family: 'Orbitron', sans-serif;
          font-size: 1rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 3px;
        }

        .sel-btns { display: flex; flex-direction: column; gap: 1.2rem; }

        .sel-btn {
          display: flex;
          align-items: center;
          gap: 1.2rem;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,68,68,0.15);
          border-radius: 4px;
          padding: 1.5rem;
          cursor: pointer;
          transition: all 0.25s ease;
          text-align: left;
          position: relative;
          overflow: hidden;
        }
        .sel-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(255,68,68,0.05), transparent);
          opacity: 0;
          transition: opacity 0.3s;
        }
        .sel-btn:hover::after, .sel-btn.active::after { opacity: 1; }
        .sel-btn:hover, .sel-btn.active {
          border-color: rgba(255,68,68,0.5);
          transform: translateX(4px);
          box-shadow: inset 0 0 20px rgba(255,68,68,0.05), 0 0 20px rgba(255,68,68,0.08);
        }
        .sel-btn.active {
          background: rgba(255,68,68,0.08);
          border-color: #ff4444;
        }

        .sel-icon { width: 44px; flex-shrink: 0; }

        .sel-info { flex: 1; display: flex; flex-direction: column; gap: 2px; }
        .sel-code {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.6rem;
          color: #ff4444;
          letter-spacing: 1.5px;
        }
        .sel-title {
          font-family: 'Rajdhani', sans-serif;
          font-size: 1.1rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.5px;
        }
        .sel-sub {
          font-size: 0.85rem;
          color: #7a8a9a;
        }

        .panel-footer {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(255,68,68,0.1);
        }
        .pf-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: rgba(255,68,68,0.25);
        }
        .pf-dot.active {
          background: #ff4444;
          box-shadow: 0 0 6px #ff4444;
          animation: pulse-dot 1.5s infinite;
        }
        .pf-text {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.6rem;
          color: #ff4444;
          letter-spacing: 2px;
          margin-left: 6px;
        }

        /* CONTENT SECTION */
        .content-sec {
          position: relative;
          z-index: 2;
          padding: 2rem var(--external-content-x) var(--external-page-bottom);
          max-width: var(--external-content-max-width);
          margin: 0 auto;
        }
        .sec-shell {
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
        }
        .content-wrap {
          width: 100%;
          background: rgba(6,6,10,0.85);
          border: 1px solid rgba(255,68,68,0.12);
          border-radius: 6px;
          padding: 3.5rem;
          position: relative;
        }
        .content-wrap::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,68,68,0.6), transparent);
        }

        .content-head { text-align: center; margin-bottom: 3.5rem; }
        .ch-breadcrumb {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-bottom: 1rem;
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.7rem;
          letter-spacing: 1px;
        }
        .ch-home { color: #ff4444; }
        .ch-sep { color: #444; }
        .ch-cur { color: #aaa; }

        .ch-title {
          font-family: 'Orbitron', sans-serif;
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 900;
          color: #fff;
          letter-spacing: 4px;
          margin-bottom: 1rem;
        }
        .ch-sub {
          font-size: 1.05rem;
          color: #7a8a9a;
          max-width: 560px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* Features grid */
        .feat-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-bottom: 3.5rem;
        }
        .feat-card {
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,68,68,0.1);
          border-radius: 4px;
          padding: 2rem;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
          animation: fadeup 0.5s ease both;
        }
        .feat-card:hover {
          background: rgba(255,68,68,0.06);
          border-color: rgba(255,68,68,0.35);
          transform: translateY(-4px);
          box-shadow: 0 8px 32px rgba(255,68,68,0.1), inset 0 1px 0 rgba(255,68,68,0.1);
        }
        .fc-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 1.2rem;
        }
        .fc-icon { width: 44px; }
        .fc-badge {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.55rem;
          color: #ff4444;
          background: rgba(255,68,68,0.1);
          border: 1px solid rgba(255,68,68,0.25);
          border-radius: 2px;
          padding: 3px 8px;
          letter-spacing: 1px;
          white-space: nowrap;
        }
        .fc-title {
          font-family: 'Rajdhani', sans-serif;
          font-size: 1.2rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 1px;
          margin-bottom: 0.7rem;
          text-transform: uppercase;
        }
        .fc-desc {
          font-size: 0.92rem;
          color: #7a8a9a;
          line-height: 1.65;
        }
        .fc-glow-line {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #ff4444, transparent);
          opacity: 0;
          transition: opacity 0.3s;
        }
        .feat-card:hover .fc-glow-line { opacity: 1; }

        /* Tiers */
        .tiers-sec { margin-bottom: 3.5rem; }
        .tiers-header { margin-bottom: 2rem; }
        .tiers-tag {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.65rem;
          color: #555;
          display: block;
          letter-spacing: 1.5px;
          margin-bottom: 0.4rem;
        }
        .tiers-title {
          font-family: 'Orbitron', sans-serif;
          font-size: 1.3rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 4px;
        }
        .tiers-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 1.5rem;
        }
        .tier-card {
          background: rgba(6,6,10,0.95);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .tier-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 0 30px var(--tier-glow);
          border-color: var(--tier-color);
        }
        .tc-header {
          padding: 1.8rem;
          border-bottom: 1px solid rgba(255,255,255,0.06);
          background: rgba(255,255,255,0.02);
        }
        .tc-label {
          font-family: 'Orbitron', sans-serif;
          font-size: 0.75rem;
          font-weight: 700;
          color: var(--tier-color);
          letter-spacing: 4px;
          margin-bottom: 0.5rem;
        }
        .tc-amount {
          font-family: 'Orbitron', sans-serif;
          font-size: 1.7rem;
          font-weight: 900;
          color: #fff;
        }
        .tc-body { padding: 1.5rem 1.8rem; }
        .tc-benefit {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 0.6rem 0;
          border-bottom: 1px solid rgba(255,255,255,0.04);
          font-size: 0.9rem;
          color: #9da8b5;
        }
        .tc-benefit:last-child { border-bottom: none; }
        .tc-glow {
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 2px;
          background: var(--tier-color);
          box-shadow: 0 0 12px var(--tier-color);
        }

        /* CTA */
        .cta-block { margin-bottom: 2.5rem; }
        .cta-inner {
          background: rgba(255,34,34,0.04);
          border: 1px solid rgba(255,68,68,0.25);
          border-radius: 4px;
          padding: 3rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 3rem;
          position: relative;
          overflow: hidden;
        }
        .cta-inner::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at center left, rgba(255,34,34,0.06), transparent 70%);
          pointer-events: none;
        }
        .cta-alert {
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.65rem;
          color: #ff6644;
          letter-spacing: 2px;
          margin-bottom: 1rem;
        }
        .cta-pulse {
          width: 8px; height: 8px; border-radius: 50%;
          background: #ff4444;
          animation: pulse-dot 1s infinite;
          flex-shrink: 0;
        }
        .cta-h {
          font-family: 'Orbitron', sans-serif;
          font-size: 1.6rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.8rem;
          letter-spacing: 1px;
        }
        .cta-p { font-size: 0.95rem; color: #7a8a9a; line-height: 1.6; max-width: 480px; }

        .cta-right {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          flex-shrink: 0;
        }

        .btn-primary {
          position: relative;
          background: #ff2222;
          color: #fff;
          border: none;
          border-radius: 3px;
          padding: 0;
          cursor: pointer;
          overflow: hidden;
          font-family: 'Orbitron', sans-serif;
          font-size: 0.78rem;
          font-weight: 700;
          letter-spacing: 3px;
          transition: all 0.3s ease;
          box-shadow: 0 0 20px rgba(255,34,34,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
        }
        .btn-bg {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #ff4444, #cc0000);
          transition: opacity 0.3s;
        }
        .btn-text {
          position: relative;
          z-index: 1;
          display: block;
          padding: 1rem 2.5rem;
        }
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 0 32px rgba(255,34,34,0.5), 0 4px 20px rgba(255,34,34,0.3);
        }
        .btn-primary:hover .btn-bg { opacity: 1.2; }
        /* Shine sweep */
        .btn-primary::after {
          content: '';
          position: absolute;
          top: 0; left: -100%;
          width: 60%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
          transition: left 0.5s ease;
        }
        .btn-primary:hover::after { left: 150%; }

        .btn-secondary {
          background: transparent;
          color: #ff4444;
          border: 1px solid rgba(255,68,68,0.4);
          border-radius: 3px;
          padding: 0.9rem 2.5rem;
          cursor: pointer;
          font-family: 'Orbitron', sans-serif;
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 2.5px;
          transition: all 0.3s ease;
        }
        .btn-secondary:hover {
          background: rgba(255,68,68,0.1);
          border-color: #ff4444;
          box-shadow: 0 0 16px rgba(255,68,68,0.15);
          transform: translateY(-2px);
        }

        /* Switch */
        .switch-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1.5rem;
          padding-top: 2rem;
          border-top: 1px solid rgba(255,68,68,0.1);
        }
        .switch-label {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.7rem;
          color: #555;
          letter-spacing: 1px;
        }
        .switch-btn {
          background: none;
          border: none;
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.72rem;
          color: #ff6644;
          cursor: pointer;
          letter-spacing: 1px;
          transition: color 0.2s, text-shadow 0.2s;
        }
        .switch-btn:hover {
          color: #ff4444;
          text-shadow: 0 0 10px rgba(255,68,68,0.5);
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .hero-inner { grid-template-columns: 1fr; gap: 3rem; }
          .stats-row { grid-template-columns: repeat(2, 1fr); }
          .cta-inner { flex-direction: column; }
          .cta-right { flex-direction: row; width: 100%; }
          .btn-primary, .btn-secondary { flex: 1; text-align: center; }
        }
        @media (max-width: 768px) {
          .hero { padding: 5rem var(--external-content-x-mobile) 3rem; }
          .content-wrap { padding: 2rem 1.5rem; }
          .stats-row { grid-template-columns: repeat(4, 1fr); gap: 0.6rem; }
          .stat-num { font-size: 1.3rem; }
          .tiers-grid { grid-template-columns: 1fr; }
          .switch-row { flex-direction: column; gap: 0.8rem; }
        }
        @media (max-width: 480px) {
          .stats-row { grid-template-columns: repeat(2, 1fr); }
          .cta-right { flex-direction: column; }
          .hero-desc { font-size: 1rem; }
        }
      `}</style>
    </div>
  );
};

export default Welcome;